import { useEffect, useLayoutEffect } from "react";
import { analyticsConfig } from "@/config";
import i18n from "@/i18n";
import { notify, registerContext, setActiveSink } from "./notify";
import { createPostHogSink } from "./sinks/posthogSink";
import type { AnalyticsSink } from "./sinks/types";

function viewportClass(width: number): "narrow" | "medium" | "wide" {
  if (width < 768) return "narrow";
  if (width < 1440) return "medium";
  return "wide";
}

function startSink(): AnalyticsSink | null {
  const { host, key } = analyticsConfig;
  if (!host || !key) {
    return null;
  }
  try {
    return createPostHogSink({ host, key });
  } catch {
    return null;
  }
}

export function useAnalyticsSink(): void {
  useLayoutEffect(() => {
    registerContext({
      appVersion: __APP_VERSION__,
      environment: analyticsConfig.environment,
      locale: i18n.resolvedLanguage ?? "unknown",
      viewportClass: viewportClass(window.innerWidth),
    });
  }, []);

  useEffect(() => {
    const sink = startSink();
    if (!sink) {
      return;
    }
    setActiveSink(sink);
    notify("app.session.started", { viewportClass: viewportClass(window.innerWidth), online: navigator.onLine });
    return () => setActiveSink(null);
  }, []);
}
